import { useEffect, useContext, useMemo } from "react";

import { AdditionalOfferViewStore } from "@state/stores/offer/shared/AdditionalOfferViewStore";
import { useRootAppStore } from "@hooks";
import {
	useGetAdditionalOfferEvent,
	useGetIsAdditionalLive,
} from "@utils/offer";
import { SetIsAdditionalOfferOpenCtxProviderForParentLayout } from "@state/context/additional-offer/SetIsAdditionalOfferOpenCtxProviderForParentLayout";
import { AdditionalOfferContainerRefContext } from "@state/context/additional-offer/AdditionalOfferContainerRefContext";
import useRemoveAdditionalOfferCount from "./useRemoveAdditionalOfferCount";

import FavoritesStore from "@state/stores/offer/shared/FavoritesStore";
import { useParams } from "react-router";

export default function useAdditionalOffer(props: {
	type?: "prematch" | "live" | undefined;
	favoritesStore: FavoritesStore;
	parentOfferStore: {
		eventsInSports: AdditionalOfferViewStore["eventsInSports"];
		eventsMap: AdditionalOfferViewStore["eventsMap"];
	};
}) {
	const eventParams = useGetAdditionalOfferEvent();
	const eventId = eventParams?.eventId;
	const params = useParams<{ period: string }>();

	const isAdditionalLive = useGetIsAdditionalLive();
	const setParentIsAdditionalOpen = useContext(
		SetIsAdditionalOfferOpenCtxProviderForParentLayout
	).setIsAdditionalOpen;
	const rootStore = useRootAppStore();
	const viewStore = useMemo(() => {
		return new AdditionalOfferViewStore(rootStore, props.favoritesStore, {
			type: props.type || "prematch",
			isLive: isAdditionalLive || false,
		});
	}, []);

	const handleAddToSlip = async () => {
		if (
			eventParams &&
			eventParams.tipId &&
			eventParams.eventId &&
			!rootStore.betSlipStore.isTipSelected(eventParams.tipId)
		) {
			await rootStore.betSlipStore.addRemoveOffer({
				id: eventParams.tipId,
				eventId: eventParams.eventId,
			});
		}
	};

	useEffect(() => {
		if (eventParams?.tipId) {
			handleAddToSlip();
		}
		return () => {
			viewStore.onDispose();
			setParentIsAdditionalOpen(false);
		};
	}, []);

	useEffect(() => {
		viewStore.updateEventId(
			eventId || null,
			isAdditionalLive,
			params.period
		);
	}, [eventId, isAdditionalLive]);

	const containerElement = useContext(AdditionalOfferContainerRefContext);

	const isThereOfferToDisplay =
		containerElement != null &&
		viewStore.events.length !== 0 &&
		eventId != null;

	useRemoveAdditionalOfferCount(
		props.parentOfferStore,
		eventId != null &&
			viewStore.events.length === 0 &&
			!viewStore.isFetchingData &&
			viewStore.isStoreInitialized
	);
	useEffect(() => {
		setParentIsAdditionalOpen(isThereOfferToDisplay);
	}, [isThereOfferToDisplay]);

	return {
		viewStore,
		isThereOfferToDisplay,
		containerElement,
	};
}
